import styled from 'styled-components';

export const WrapperLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 28px;
`;
